import AnnotationModel from './AnnotationModel';

export {
    AnnotationModel
};



// WEBPACK FOOTER //
// ./plugins/large_image/web_client/models/index.js